import React from 'react'

export default props => <svg
  width="13"
  height="13"
  viewBox="0 0 13 13"
  fill="none"
>
  <rect x="0.5" y="0.5" width="12" height="12" rx="1.5" stroke="#4F4F4F"/>
  <path d="M0 3L2.875 6L7.5 0" transform="translate(3 3)" stroke="#4F4F4F"/>
</svg>



// WEBPACK FOOTER //
// ./src/modules/CheckboxControl/CheckboxIconSvg.js